import React from "react";
import { Link } from "react-router-dom";
import Ajax, { domain } from "../ajax/Ajax";
import countries from "../resources/countries";
import currencies from "../resources/currencies";
import { Loading } from "../../App";
import { fetchBusinessCategories } from "../../utils";

let currency_list = Object.values(currencies);

class NewShop extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      name: "",
      country: "US",
      city: "",
      address: "",
      email: "",
      phone: "",
      businessType: "",
      businessCategory: "",
      usesWareHouse: false,
      stepOneDone: false,
      currency: "USD",
      categories: null,
      selectedCategories: [],
    };

    this.saveNewShop = this.saveNewShop.bind(this);
  }

  async saveNewShop(event) {
    event.preventDefault();

    let details = {
      name: this.state.name,
      country: this.state.country,
      city: this.state.city,
      address: this.state.address,
      email: this.state.email,
      phone: this.state.phone,
      currency: this.state.currency,
      business_type: this.state.businessType,
      business_category: this.state.businessCategory,
      uses_warehouse: this.state.usesWareHouse,
      categories: this.state.selectedCategories,
    };
    let data = {
      details: details,
    };

    this.setState({
      submitting: true,
    });

    let response = await Ajax.postData(
      domain + "/en/api/accounts/v1/shops/",
      data
    );
    console.log(response);

    if (response) {
      if (response.status === 200) {
        this.setState({
          shopCreatedSuccessfully: true,
          submitting: false,
        });

        localStorage.setItem("user", JSON.stringify(response.user));

        setTimeout(function () {
          window.location.assign("/myshop/home/");
        }, 1000);
      } else {
        this.setState({
          shopCreationError: true,
          submitting: false,
        });
      }
    } else {
      this.setState({
        shopCreationError: true,
        submitting: false,
      });
    }
  }

  async componentDidMount() {
    let categories = await fetchBusinessCategories();
    if (categories) {
      this.setState({
        categories: categories,
      });
    }
  }

  render() {
    let submitting = "";
    if (this.state.submitting) {
      submitting = "is-loading";
    }
    return (
      <div className="animated fadeIn">
        <div className="mt-5 pt-5">
          <br />
        </div>
        <div className="container">
          <div className="columns">
            <div className="column is-3"></div>
            <div className="column is-6">
              <div className="card bordered-card is-shadowless">
                <div className="card-body">
                  {this.state.shopCreatedSuccessfully ? (
                    <div>
                      <div className="message is-success">
                        <div className="message-body">
                          <div className="is-size-3 has-text-centered has-text-success">
                            <span className="zmdi zmdi-check-circle"></span>
                          </div>

                          <div className="is-size-5 has-text-centered">
                            Business added successfully!
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="m-4">
                      <div className="is-size-3 has-text-centered has-text-info">
                        <span className="fas fa-university"></span>
                      </div>
                      <div className="is-size-4 has-text-centered">
                        Add Business
                      </div>

                      {this.state.shopCreationError ? (
                        <div>
                          <div className="message is-danger">
                            <div className="message-body">
                              <div className="is-size-3 has-text-centered has-text-danger">
                                <span className="zmdi zmdi-close-circle"></span>
                              </div>

                              <div className="is-size-5 has-text-centered">
                                An error occurred. Please try again later.
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div></div>
                      )}

                      <div className="mt-2">
                        {!this.state.stepOneDone ? (
                          <form
                            className="animated fadeIn"
                            action="#"
                            onSubmit={(event) => {
                              event.preventDefault();
                              this.setState({ stepOneDone: true });
                            }}
                          >
                            <div className="field">
                              <label className="label">Name</label>
                              <div className="control">
                                <input
                                  onChange={(event) =>
                                    this.setState({
                                      name: event.target.value,
                                    })
                                  }
                                  value={this.state.name}
                                  required
                                  className="input"
                                  type="text"
                                  placeholder="name of business"
                                />
                              </div>
                            </div>

                            <div className="field">
                              <label className="label">Country</label>
                              <div className="control select is-fullwidth">
                                <select
                                  onChange={(event) => {
                                    this.setState({
                                      country: event.target.value,
                                    });
                                  }}
                                  value={this.state.country}
                                  name="country"
                                  className="select"
                                >
                                  {countries.map((country) => (
                                    <option value={country.Code}>
                                      {country.Name}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>

                            <div className="field">
                              <label className="label">
                                Currency of operation
                              </label>
                              <div className="control select is-fullwidth">
                                <select
                                  onChange={(event) => {
                                    this.setState({
                                      currency: event.target.value,
                                    });
                                  }}
                                  value={this.state.currency}
                                  name="currency"
                                  className="select"
                                >
                                  {currency_list.map((currency) => (
                                    <option value={currency.code}>
                                      {currency.symbol} - {currency.name}{" "}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>

                            <div className="field">
                              <label className="label">City</label>
                              <div className="control">
                                <input
                                  value={this.state.city}
                                  onChange={(event) => {
                                    this.setState({
                                      city: event.target.value,
                                    });
                                  }}
                                  required
                                  className="input"
                                  type="text"
                                  placeholder="city"
                                />
                              </div>
                            </div>

                            <div className="field">
                              <label className="label">Address</label>
                              <div className="control">
                                <input
                                  value={this.state.address}
                                  onChange={(event) => {
                                    this.setState({
                                      address: event.target.value,
                                    });
                                  }}
                                  className="input"
                                  type="text"
                                  placeholder="address"
                                />
                              </div>
                            </div>

                            <div className="field">
                              <label className="label">Email</label>
                              <div className="control">
                                <input
                                  value={this.state.email}
                                  onChange={(event) => {
                                    this.setState({
                                      email: event.target.value,
                                    });
                                  }}
                                  required
                                  className="input"
                                  type="email"
                                  placeholder="email"
                                />
                              </div>
                            </div>

                            <div className="field">
                              <label className="label">Phone</label>
                              <div className="control">
                                <input
                                  value={this.state.phone}
                                  onChange={(event) => {
                                    this.setState({
                                      phone: event.target.value,
                                    });
                                  }}
                                  required
                                  className="input"
                                  type="text"
                                  placeholder="+1 856 69 4582"
                                />
                              </div>
                            </div>

                            <div className="field d-flex justify-content-between mt-2">
                              <div>
                                <Link to="/myshop/home/">
                                  <button type="button" className="button">
                                    <span className="zmdi zmdi-close-circle mr-1"></span>
                                    <span>Cancel</span>
                                  </button>
                                </Link>
                              </div>
                              <div>
                                <button className="button is-info">
                                  <span className="mr-2">Next</span>{" "}
                                  <span className="zmdi zmdi-arrow-forward"></span>
                                </button>
                              </div>
                            </div>
                          </form>
                        ) : (
                          <form
                            className="animated fadeIn"
                            action="#"
                            onSubmit={this.saveNewShop}
                          >
                            <div className="field">
                              <label className="label">
                                Select the ones that apply to your business
                              </label>
                              <div>
                                {this.state.categories ? (
                                  <div>
                                    {this.state.categories.map((cat) => (
                                      <label
                                        key={cat.id + "-b-cat"}
                                        className="checkbox m-3 is-size-5"
                                      >
                                        <input
                                          onChange={(event) => {
                                            if (event.target.checked) {
                                              let selected = this.state
                                                .selectedCategories;
                                              selected.push(cat);
                                              this.setState({
                                                selectedCategories: selected,
                                              });
                                            } else {
                                              let newCat = [];
                                              let selected = this.state
                                                .selectedCategories;
                                              selected.forEach((ele) => {
                                                if (!(cat.id === ele.id)) {
                                                  newCat.push(ele);
                                                }
                                              });
                                              this.setState({
                                                selectedCategories: newCat,
                                              });
                                            }
                                          }}
                                          name="category"
                                          type="checkbox"
                                        />
                                        <span className="m-1">{cat.name}</span>
                                      </label>
                                    ))}
                                  </div>
                                ) : (
                                  <div>
                                    <Loading />
                                  </div>
                                )}
                              </div>
                            </div>

                            <div className="field">
                              <label className="label">Business Category</label>
                              <div className="control select is-fullwidth">
                                <select
                                  onChange={(event) => {
                                    this.setState({
                                      country: event.target.value,
                                    });
                                  }}
                                  value={this.state.businessCategory}
                                  name="business_type"
                                  className="select"
                                >
                                  <option value="United States of America">
                                    RETAIL
                                  </option>
                                  <option value="Canada">WHOLE SALE</option>
                                  <option value="Cameroon">
                                    WHOLE SALE & RETAIL
                                  </option>
                                </select>
                              </div>
                            </div>

                            <div className="field">
                              <label className="label">
                                Do you use a separate warehouse to supply your
                                sales points?
                              </label>
                              <div className="control">
                                <label className="radio">
                                  <input type="radio" name="foobar" />
                                  <span className="ml-1">Yes</span>
                                </label>
                                <label className="radio ml-2">
                                  <input
                                    onChange={(event) => {
                                      if (event.target.checked) {
                                        this.setState({
                                          usesWareHouse: false,
                                        });
                                      } else {
                                        this.setState({
                                          usesWareHouse: true,
                                        });
                                      }
                                    }}
                                    type="radio"
                                    name="foobar"
                                    checked
                                  />
                                  <span className="ml-1">No</span>
                                </label>
                              </div>
                            </div>

                            <div className="d-flex justify-content-between mt-5">
                              <div>
                                <button
                                  onClick={() => {
                                    this.setState({
                                      stepOneDone: false,
                                    });
                                  }}
                                  type="button"
                                  className="button"
                                >
                                  <span className="zmdi zmdi-arrow-back mr-2"></span>
                                  <span>Back</span>
                                </button>
                              </div>
                              <div>
                                <button
                                  className={"button is-info " + submitting}
                                >
                                  <span className="mr-2">Submit</span>{" "}
                                  <span className="zmdi zmdi-arrow-forward"></span>
                                </button>
                              </div>
                            </div>
                          </form>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="column is-3"></div>
          </div>
        </div>
        <div className="mt-5 pt-5">
          <br />
        </div>
      </div>
    );
  }
}

export default NewShop;
